import usePortalId from 'hooks/portal/usePortalId';
import { useFormDetail, useHubspotForms } from 'api/apiHooks';
import Form from './child/Form';
import { useParams, useNavigate } from 'react-router-dom';
import { PATH_PAGE } from 'routes/paths';
import PartialPageSpinner from 'components/PartialPageSpinner';
import { useEffect } from 'react';
import { removeProducts } from 'redux/slices/productFormEditor';
import { dispatch } from 'redux/store';

const FormEditor = () => {
  const navigate = useNavigate();
  const { formId } = useParams<{ formId: string }>();
  const portalId = usePortalId();
  const hubspotFormData = useHubspotForms(portalId);
  const formData = useFormDetail(formId!);

  useEffect(() => {
    return () => {
      dispatch(removeProducts());
    };
  }, []);

  if (formData.isError) {
    navigate(PATH_PAGE.page404);
  }
  if (hubspotFormData.data === undefined || formData.data === undefined) {
    return <PartialPageSpinner />;
  }
  if (
    formData.data.data.portal_id.toString() !== portalId ||
    formData.data.success === false
  ) {
    navigate(PATH_PAGE.page404);
  }

  const formDataDetails = formData.data.data;

  return (
    <Form
      hubspotFormData={hubspotFormData.data.data}
      formData={formDataDetails}
    />
  );
};

export default FormEditor;
